import React from 'react';
import { Link } from 'react-router-dom';
import { Clock3, Shield } from 'lucide-react';

const AdminPendingApproval = () => {
  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="w-full max-w-xl admin-glass rounded-2xl p-8 border border-red-700/30 text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r from-red-700 to-red-800 rounded-full mb-5">
          <Clock3 className="w-8 h-8 text-white" />
        </div>
        <h1 className="text-3xl font-bold text-slate-100 mb-3">Admin Approval Pending</h1>
        <p className="text-slate-300 mb-3">Your admin account request is under review.</p>
        <p className="text-slate-400 text-sm mb-8">You will be able to access the dashboard once an existing administrator approves your request.</p>

        <div className="inline-flex items-center gap-2 border border-red-700/40 bg-red-900/20 rounded-lg px-4 py-2 text-sm text-red-200 mb-8">
          <Shield className="w-4 h-4" />
          Status: pending approval
        </div>

        <div>
          <Link to="/login" className="inline-flex items-center justify-center px-6 py-3 border border-slate-600 text-slate-200 rounded-lg hover:bg-slate-800/60 transition-colors">
            Back to admin login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AdminPendingApproval;
